module.exports = __webpack_public_path__ + "img/work-sans-v4-latin-ext-200.8e15fcf6.svg";